exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-quantity[data-v-71bcf5bf]{position:relative}.product-quantity[data-v-71bcf5bf] .spinner{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}\n", ""]);

// exports
